// extracted by mini-css-extract-plugin
export default {"container":"adminNasiPredlozi_container__gydMj","top":"adminNasiPredlozi_top__GXGWT","btn":"adminNasiPredlozi_btn__xpEYU","postContainer":"adminNasiPredlozi_postContainer__NwuUB"};